import { createStyles, makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      margin: '0',
      display: 'flex',
      height: '20rem',
      alignItems: 'center',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        height: '15rem'
      },
      [theme.breakpoints.down('xs')]: {
        height: '75.153vw'
      }
    },
    background: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      backgroundPositionY: 'center',
      backgroundPositionX: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      [theme.breakpoints.down('xs')]: {
        backgroundSize: 'cover',
        alignItems: 'unset',
        justifyContent: 'center'
      }
    },
    title: {
      width: '100%',
      fontSize: '3rem',
      fontWeight: 'bold',
      fontFamily: 'Iliad-Regular',
      textAlign: 'start',
      maxWidth: '50%',
      color: 'transparent',
      userSelect: 'none',
      [theme.breakpoints.down('xs')]: {
        maxWidth: 'unset',
        textAlign: 'center',
        fontSize: '2rem',
        marginTop: '0 !important'
      },
      '&& > span': {
        display: 'block'
      },
      [theme.breakpoints.up('sm')]: {
        paddingLeft: '4rem'
      }
    },
    standFirst: {
      marginTop: '3rem',
      padding: '0 5rem',
      [theme.breakpoints.down('xs')]: {
        padding: 0
      }
    }
  })
)
